<ng-container *ngIf="isEmulatedUser$ | async; else realUser">
  <h4 class="error">Доступ запрещен</h4>
</ng-container>

<ng-template #realUser>
  <div *ngIf="isLoading$ | async; else loaded" class="spinner">
    <sd-spinner [size]="100"></sd-spinner>
  </div>

  <ng-template #loaded>
    <h4 class="error" *ngIf="isError$ | async; else content">Не удалось загрузить банковские карты</h4>
  </ng-template>

  <ng-template #content>
    <sd-payment-list
      *ngIf="hasPayments$ | async; else noPayments"
      class="payment-list"
      [payments]="payments$ | async"
      (addPayment)="addPayment()"
      (removePayment)="removePayment($event)"
    ></sd-payment-list>

    <ng-template #noPayments>
      <sd-no-payments class="no-payments" (addPayment)="addPayment()"></sd-no-payments>
    </ng-template>
  </ng-template>
</ng-template>
